var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecursos2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 243,
    viewBox: "0 0 325 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -11,
    width: 325,
    height: 254
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.36 -11H0V243H324.36V-11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.751 177.773H21.5662C20.1866 177.773 19.061 176.655 19.061 175.269V43.8217C19.061 42.442 20.1791 41.3169 21.5662 41.3169H286.751C288.13 41.3169 289.256 42.4354 289.256 43.8217V175.276C289.256 176.655 288.137 177.773 286.751 177.773Z",
    fill: "#ECFFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.323 183.178V211.306C295.323 215.532 291.9 218.955 287.675 218.955H20.6486C16.4218 218.955 13 215.532 13 211.306V183.178H295.323Z",
    fill: "#C6EAE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.574 41.8994V179.429H16.7422V41.8994C16.7422 39.744 18.4863 38 20.6419 38H287.668C289.833 38 291.574 39.7461 291.574 41.8994Z",
    stroke: "#4C2D86",
    strokeWidth: 7.49765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.072 246.079C184.357 231.72 184.289 218.961 184.289 218.961H154.158H124.028C124.028 218.961 123.96 231.713 116.245 246.079C110.506 256.767 101.659 259.213 101.659 259.213H154.158H206.659C206.659 259.205 197.811 256.761 192.072 246.079Z",
    fill: "#C6EAE6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.506,
    cy: 108.324,
    rx: 39,
    ry: 33.5,
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.612 108.555L149.27 119.206L149.455 97.5566L169.612 108.555Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.289 218.071H124.027V219.852H184.289V218.071Z",
    fill: "#92C4BE"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecursos2);
export default __webpack_public_path__ + "static/media/recursos2.fb3d3868d796857f04692c7b2daeb7ed.svg";
export { ForwardRef as ReactComponent };